//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'NavItemFlat',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};